'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SellerRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

var _take = require('lodash/take');

var _take2 = _interopRequireDefault(_take);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SellerRemote = exports.SellerRemote = {
    fetchSellers: function fetchSellers(_ref) {
        var deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)({ deployment: deployment, path: '<ITEM-API>spa/small/sellers' });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchSellersByIds: function fetchSellersByIds(_ref2) {
        var authToken = _ref2.authToken,
            deployment = _ref2.deployment,
            sellerIds = _ref2.sellerIds;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>spa/small/sellers' });
            request.send({ ids: sellerIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postFollow: function postFollow(_ref3) {
        var authToken = _ref3.authToken,
            deployment = _ref3.deployment,
            sellerId = _ref3.sellerId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>follow-seller/' + sellerId });
            request.type('form');
            request.send({ sellerId: sellerId });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postMessage: function postMessage(_ref4) {
        var authToken = _ref4.authToken,
            deployment = _ref4.deployment,
            messageDetails = _ref4.messageDetails;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({
                authToken: authToken,
                deployment: deployment,
                path: '<MAINHOST-API>api/s_msg',
                queryParams: { client_version: '4.3' }
            });

            if (!messageDetails) reject(new Error('no message details sent'));

            var catalogId = messageDetails.catalogId,
                files = messageDetails.files,
                sellerId = messageDetails.sellerId,
                message = messageDetails.message,
                itemId = messageDetails.itemId,
                subject = messageDetails.subject;


            request.field('cat_id', catalogId || 0).field('cc_sender', false).field('house_id', sellerId).field('lot_id', itemId || 0).field('message_text', message).field('subject', subject);

            (0, _take2.default)(files || [], 5).forEach(function (f, idx) {
                var fieldName = idx === 0 ? 'attach' : 'attach' + idx;
                request.attach(fieldName, f);
            });

            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postUnfollow: function postUnfollow(_ref5) {
        var authToken = _ref5.authToken,
            deployment = _ref5.deployment,
            sellerId = _ref5.sellerId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>unfollow-seller/' + sellerId });
            request.type('form');
            request.send({ sellerId: sellerId });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/seller.js
// module id = e6NR
// module chunks = 60